// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Benin from '../_raw/flag/icon_flag_benin.png';

export default () => <img src={Benin} alt="Benin" />;
